import { type FunctionComponent } from "react";

import { type BTSelectItem } from "types/apiResponse/apiResponse";

import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import { type ICostCodeSelectorExtraData } from "commonComponents/entity/costCode/CostCodeSelector/CostCodeSelector";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

import { type AcctCostCode } from "entity/costCode/CostCodeExportToAccounting/CostCodeExportToAccounting.api.types";
import { type IReceiptCostCodeSelectorExtraData } from "entity/receipt/Receipt.api.types";

import "./CostCodeTitle.less";

interface ICostCodeItemTitleProps {
    item:
        | BTSelectItem<ICostCodeSelectorExtraData>
        | BTSelectItem<AcctCostCode>
        | BTSelectItem<IReceiptCostCodeSelectorExtraData>;
}

const isIReceiptCostCodeSelectorExtraData = (
    item:
        | BTSelectItem<ICostCodeSelectorExtraData>
        | BTSelectItem<AcctCostCode>
        | BTSelectItem<IReceiptCostCodeSelectorExtraData>,
): item is BTSelectItem<IReceiptCostCodeSelectorExtraData> => {
    return (
        (item as BTSelectItem<IReceiptCostCodeSelectorExtraData>).extraData?.displayInactiveTag !==
            undefined ||
        (item as BTSelectItem<IReceiptCostCodeSelectorExtraData>).extraData?.isActive !== undefined
    );
};

export const CostCodeItemTitle: FunctionComponent<ICostCodeItemTitleProps> = ({ item }) => {
    if (item?.extraData && isIReceiptCostCodeSelectorExtraData(item)) {
        const activeStatus = item?.extraData.isActive;
        const displayStatus = item?.extraData.displayInactiveTag;
        if (displayStatus && activeStatus !== undefined && !activeStatus) {
            return (
                <BTRow justify="space-between">
                    <BTCol className="align-title">{item.title}</BTCol>
                    <BTCol className="align-tag">
                        <StatusTagDisplay
                            statusText="Inactive"
                            statusType=""
                            className="status-text status-tag"
                        />
                    </BTCol>
                </BTRow>
            );
        }
    }

    return <>{item.title}</>;
};
